import React from "react";
import {Box} from "@mui/material";
import MapPage from "./MapPage";
import MapInseePage from "../dpeByInsee/MapInseePage";

export default function DPE() {

    const [codeIris, setCodeIris] = React.useState(undefined);
    const [codeInsee, setCodeInsee] = React.useState(undefined);
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    React.useEffect(() => {
        let iris = params.get("code_iris");
        let insee = params.get("code");
        if (!iris && !insee) {
            iris = "132060602"
        }

        if (iris) {
            setCodeIris(iris);
        }
        if (insee) {
            setCodeInsee(insee);
        }
    }, []);

    if (codeIris) {
        return (<MapPage codeIris={codeIris}/>)
    } else if (codeInsee) {
        return (<MapInseePage code={codeInsee}/>)
    } else {

        return (<Box/>)
    }


}
